import React from 'react';
import { Box, Typography } from '@mui/material';
// import TableComponent from '../Table/TableComponent';
// import GiftSubHero from '../SubHero/SubHero';
import MoreGifts from '../MoreItems/MoreItems';
import { useParams } from 'react-router-dom';
import { useGet } from '../../hooks/useApi';

const GiftDetailsDescription = () => {
    const {id} = useParams()

    const { data: itemDetails} = useGet(`/api/GiftItems/get-item-details/${id}`);
    const items = itemDetails?.data
    // const {longDesciption,name,size,} = item
    
  return (
    <Box>
        <Box sx={{backgroundColor:'rgba(255, 255, 255, 1)', my:4, p:2, borderRadius:'12px',fontFamily: theme=> theme.typography.smallText,}}>
            <Typography variant='h6' sx={{color:'rgba(18, 18, 18, 0.8)', my:2, fontSize:{xs:'1rem', fontWeight:'600', md:'2rem'}}}>
                Spring a Surprise on Your Loved Ones
            </Typography>
            <Typography sx={{lineHeight:'2rem', color:'rgba(18, 18, 18, 0.8)'}}>
                Celebrate love, joy, and special moments with the timeless beauty of our <b style={{color:'rgba(18, 18, 18, 0.8)'}}>Elegant Flower Bouquet - Red Rose</b>. Handpicked for their freshness
                and vibrant color, these 20 premium red roses are expertly arranged in eco-friendly, luxurious wrapping. This bouquet is the utlimate symbol of
                romance and appreciation, perfect for anniversaries, birthdays or simply brighttening someone's day.
            </Typography>
            <Typography sx={{lineHeight:'2rem', my:3, color:'rgba(18, 18, 18, 0.8)'}}>
                <span style={{color:'rgba(86, 4, 246, 1)', fontWeight:'500'}}>Make it more persoanl with a customed message card included  at checkout.</span> Whether it it romantic gesture or a heart-felt thank-you,
                 this elegant bouquet delivers your feelings in the most beautiful way. Same-day deliveryavailable in Lagos to ensure your thoughtful gift arrives right on time.
            </Typography>
        </Box>
        {/* <TableComponent/> */}
        {/* <GiftSubHero/> */}
        <MoreGifts title={'More Gifts from Lush Green Store'} items={items}/>
    </Box>
  )
}

export default GiftDetailsDescription